import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

//- material ui
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CloseIcon from '@material-ui/icons/Close';
//import Button from "@material-ui/core/Button";
//import Zoom from "@material-ui/core/Zoom";

//- local ui
import { getGlobalClasses } from '../../themes';
import { post } from '../../modules/utility';
import AuthUserContainer from '../../containers/AuthUser';
import FormComponent from '../../components/FormComponent';
//import FormSelect from "../../components/form/FormSelect";
//import FormTextArea from "../../components/form/FormTextArea"

import CircularProgress from '@material-ui/core/CircularProgress';
// import Table from "@material-ui/core/Table";
// import EnhancedTableHead from "../../components/table/EnhancedTableHead";
// import TableBody from "@material-ui/core/TableBody";
// import { PureRecordRow, sortTable } from "../../libs/tableUtilities";
//import TableRow from "@material-ui/core/TableRow";
// import TableCell from "@material-ui/core/TableCell";

//- icons / images
//import CircularProgress from "@material-ui/core/CircularProgress";
import GreenChecked from '../../images/icons/greenChecked.svg';
import WarningIconSvg from '../../images/icons/warningIcon.svg';
import ErrorIcon from '@material-ui/icons/Error';
// import CheckIcon from "@material-ui/icons/Check";
import IconButton from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import EnhancedTable from '../../components/table/EnhancedTable';
import copyToClipboardSvg from '../../images/icons/copyToClipboard.svg';
import copyToClipboardSuccessSvg from '../../images/icons/copyToClipboardSuccess.svg';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Slide from '@material-ui/core/Slide';
import { green } from '@material-ui/core/colors';
import CheckIcon from '@material-ui/icons/Check';

import Button from '@material-ui/core/Button';
import { red } from '@material-ui/core/colors';
import ClockOutEmployeeDialog from '../../components/dialogs/ClockOutEmployeeDialog';
import UpdateEmployeeTimeShiftDialog from '../../components/dialogs/UpdateEmployeeTimeShiftDialog';
import RemoveTimeShiftDialog from '../../components/dialogs/RemoveTimeShiftDialog';
import { Popover } from '@material-ui/core';
import ClearTimeShiftAudit from '../../components/dialogs/ClearTimeShiftAudit';
import UpdateEmployeeClockInDialog from '../../components/dialogs/UpdateEmployeeClockInDialog';
import Tooltip from '@material-ui/core/Tooltip';

const SlideUpTransition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		submitButton: {
			marginTop: 30,
			fontSize: 16,
			borderRadius: '100px',
			padding: '12px 40px',
			textTransform: 'uppercase',
			marginRight: 10,
			lineHeight: '20px',
			height: 70,
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: 33,
			height: 33,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 2,
			marginLeft: 5,
		},
		isSaving: {
			marginLeft: 20,
			fontSize: 16,
			color: '#1565C0',
		},
		savingSuccessful: {
			marginLeft: 20,
			fontSize: 16,
			color: '#2E7D32',
		},
		smallWarningIcon: {
			display: 'inline-block',
			width: 28,
			height: 28,
			backgroundImage: `url('${WarningIconSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 0,
			marginTop: -6,
		},
		smallErrorIcon: {
			width: 28,
			height: 28,
			color: red[500],
			marginLeft: 0,
			marginTop: -6,
			marginRight: 5,
			verticalAlign: 'middle',
		},

		miniWarningIcon: {
			display: 'inline-block',
			width: 22,
			height: 22,
			backgroundImage: `url('${WarningIconSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 0,
			marginTop: 6,
		},
		miniErrorIcon: {
			width: 22,
			height: 22,
			color: red[400],
			marginLeft: 0,
			marginTop: 0,
			marginRight: 2,
			verticalAlign: 'middle',
		},

		warningContainer: {
			borderRadius: 5,
			border: '1px solid #ccc',
			padding: 20,
			marginTop: 10,
			marginBottom: 10,
		},

		xContainer: {
			marginTop: 10,
			marginBottom: 40,
		},
		xLabel: {
			fontSize: 24,
			fontWeight: 600,
			marginTop: 15,
			marginBottom: 10,
		},
		xDescription: {
			marginTop: 5,
		},
		xConditions: {
			margin: '17px 0px 2px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#666',
			fontWeight: 900,
			letterSpacing: 2,
		},
		conditionContainer: {
			marginLeft: 0,
		},
		ruleContainer: {
			border: '1px solid #ccc',
			borderRadius: '2px',
			padding: 20,
		},
		orSpacer: {
			margin: '3px 0px',
			color: '#666',
			fontStyle: 'italic',
		},
		hasLineItem: {
			margin: '12px 0px 0px 0px',
			textTransform: 'uppercase',
			fontSize: 13,
			color: '#555',
			//fontWeight : 00,
			letterSpacing: 2,
			marginLeft: 5,
		},
		detailRuleContainer: {
			paddingLeft: 10,
			margin: '5px 5px 5px 5px',
			borderLeft: '2px solid #ddd',
		},

		runningSearch: {
			paddingLeft: 20,
			display: 'flex',
			alignItems: 'center',
			fontSize: 18,
			color: '#666',
		},
		totalStats: {
			fontSize: 18,
			paddingLeft: 10,
			margin: '10px 0',
		},
		totalMatched: {
			fontSize: 24,
			paddingLeft: 10,
			margin: '10px 0',
			marginTop: 30,
			borderBottom: `1px solid #eee`,
		},
		matchContainer: {
			//borderLeft : '2px solid #ccc',
			paddingLeft: 20,
			marginTop: 20,
		},
		list: {
			paddingTop: 10,
		},

		// table classes
		buttonDivider: {
			borderTop: '1px dashed #999',
			marginTop: 5,
			paddingTop: 5,
		},

		textDivider: {
			borderTop: '1px dashed #999',
			marginTop: 10,
			paddingTop: 10,
			paddingLeft: 3,
			paddingRight: 3,
		},
		tinyPadding: {
			paddingLeft: 3,
			paddingRight: 3,
		},
		eventDivider: {
			borderTop: '1px solid #ccc',
			marginTop: 5,
			paddingTop: 5,
		},

		paddedContainer: {
			paddingBottom: 8,
			paddingTop: 8,
		},
		noteCell: {
			borderRadius: 4,
			fontSize: 13,
			padding: '2px 9px',
			minWidth: 'auto',
			fontWeight: 600,
			marginRight: 3,
		},
		popover: {
			pointerEvents: 'none',
		},
		popoverContainer: {
			padding: 20,
			fontSize: 14,
		},
		popoverShiftContainer: {
			marginBottom: 25,
		},
		popoverShiftTitle: {
			textTransform: 'uppercase',
			color: '#444',
			letterSpacing: '1px',
			borderBottom: '1px solid #ccc',
			marginBottom: 5,
			fontWeight: 800,
		},
		eventNote: {},
		eventDateTime: {
			fontSize: '80%',
			color: '#666',
		},
		copyToClipboardIcon: {
			display: 'inline-block',
			width: 20,
			height: 20,
			backgroundImage: `url('${copyToClipboardSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginLeft: 5,
			cursor: 'pointer',
		},
		copyToClipboardSuccessIcon: {
			display: 'inline-block',
			width: 20,
			height: 20,
			backgroundImage: `url('${copyToClipboardSuccessSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginLeft: 5,
			cursor: 'pointer',
		},
		snackbarSuccess: {
			backgroundColor: green[600],
		},
		snackbarIcon: {
			opacity: 0.9,
			marginRight: theme.spacing(1),
			fontSize: 20,
		},
		snackbarMessage: {
			display: 'flex',
			alignItems: 'center',
		},
	};
};

// const GROUP_BY_DATE = true;
const punchTypeDescriptions = {
	ID: 'In Day — clock in starting the work day',
	IL: 'In Lunch — clock in returning from a lunch break',
	OL: 'Out Lunch — clock out leaving for a lunch break',
	OD: 'Out Day — clock out done for the day',
};

const managerEventToDisplay = {
	managerClockIn: 'clocked in employee',
	managerClockOut: 'clocked out employee',
	managerUpdate: 'updated employee shift',
	managerAdd: 'added employee shift',
	managerRemove: 'deleted employee shift',
};

class ShiftTable extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			isSearching: false,

			isClockOutEmployeeDialogOpen: false,
			isUpdateEmployeeDialogOpen: false,
			timeClockShiftForClockOut: undefined,
			isRemoveShiftDialogOpen: false,
			timeClockShiftForRemove: undefined,

			isClearAuditDialogOpen: false,
			timeClockShiftsForClearAudit: undefined,

			isChangeClockInOpen: false,

			popoverIsOpen: false,
			popoverAnchor: undefined,
			popoverTimeClockShifts: [],
		};
	}

	componentDidMount() {
		//- apiResults mode: the parent already fetched the data — just format it
		if (this.props.apiResults) {
			this.formatTimeShiftSearchResults(this.props.apiResults);
			return;
		}
		if (!this.props.paused) {
			this.runApi();
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.apiResults) {
			if (prevProps.apiResults !== this.props.apiResults) {
				this.formatTimeShiftSearchResults(this.props.apiResults);
			}
			return;
		}
		if (prevProps.paused !== this.props.paused) {
			this.runApi();
		}
		if (prevProps.refreshId !== this.props.refreshId) {
			this.runApi();
		}
	}

	runApi = () => {
		const { method, params, showErrors, onDataCallback, apiResults, onRefreshNeeded } = this.props;

		//- apiResults mode: shifts changed (updated / cleared / removed) — ask the
		//- parent to re-fetch since this table doesn't own the API call
		if (apiResults && !method) {
			if (onRefreshNeeded) {
				onRefreshNeeded();
			}
			return;
		}
		this.setState({ isSearching: true });
		post({
			method,
			params,
			callback: (err, r) => {
				this.setState({ isSearching: false });
				if (err) {
					showErrors(err);
					return;
				}
				try {
					this.formatTimeShiftSearchResults(r);
					if (onDataCallback) {
						onDataCallback(_.get(r, 'collections.timeClockShiftCollection', []));
					}
				} catch (err) {
					console.log(err);
					throw err;
				}
			},
		});
	};

	formatTimeShiftSearchResults = (apiResults) => {
		const { classes, excludeShiftIds } = this.props;
		const collections = _.get(apiResults, 'collections');
		let timeClockShifts = _.get(collections, 'timeClockShiftCollection', []);

		if (!_.isEmpty(excludeShiftIds)) {
			timeClockShifts = timeClockShifts.filter(
				(timeClockShift) => !_.includes(excludeShiftIds, timeClockShift.timeClockShiftId)
			);
		}

		const userMap = _.keyBy(_.get(collections, 'userCollection', []), 'userId');
		const timeClockLocationLookup = _.keyBy(
			_.get(collections, 'timeClockLocationCollection', []),
			'timeClockLocationId'
		);

		const now = moment();
		const timeClockShiftsByUserAndDate = {};
		const timeClockShiftRows = [];

		timeClockShifts.forEach((timeClockShift) => {
			const { clockInDateTime, shiftForUserId } = timeClockShift;

			const day = moment(clockInDateTime).tz('America/Los_Angeles');
			const key = `${shiftForUserId}_${day.format('YYYY-MM-DD')}`;
			if (!timeClockShiftsByUserAndDate[key]) {
				timeClockShiftsByUserAndDate[key] = {
					...timeClockShift,
					dowDisplay: day.format('dddd'),
					shifts: [],
				};
			}
			timeClockShiftsByUserAndDate[key].shifts.push(timeClockShift);
		});

		_.values(timeClockShiftsByUserAndDate).forEach((mastShift) => {
			//
			// Get single values for row
			//
			const {
				timeClockShiftId,
				supervisorName,
				shiftForUserId,
				dowDisplay,
				timeClockLocationId,
				shifts,
			} = mastShift;

			const user = userMap[shiftForUserId] || {
				firstName: 'Missing',
				lastName: '',
			};
			const userDisplay = `${user.firstName} ${user.lastName}`;

			let timeClockLocation = timeClockLocationLookup[timeClockLocationId] || {
				display: 'None',
			};

			//
			// Get items for EACH shift
			//
			let totalDuration = 0;
			const clockIns = [];
			const clockOuts = [];
			const durations = [];
			const allAudits = [];
			const allEvents = [];
			const orderedShifts = _.orderBy(shifts, 'clockInDateTime');
			let hasManagerEvent = false;
			let shiftForClipboard = '';
			let hasErrorOrWarning = false;

			orderedShifts.forEach((shift, i) => {
				const {
					clockInDateTime,
					clockOutDateTime,
					timeClockShiftEvents,
					auditStatus,
					auditReason,
				} = shift;

				const clockInMoment = moment(clockInDateTime);
				const clockInDateTimeDisplay = clockInMoment.format('M/D h:mm a');
				const hasClockOut = clockOutDateTime;

				let durationDiff = now.diff(clockInMoment);
				let clockOutDateTimeDisplay = 'Currently Clocked in';
				if (hasClockOut) {
					const clockOutMoment = moment(clockOutDateTime);
					clockOutDateTimeDisplay = clockOutMoment.format('M/D h:mm a');
					durationDiff = clockOutMoment.diff(clockInMoment);
				}
				let durationDisplay = moment.duration(durationDiff).format('d [days], h [hrs], m [min]');

				timeClockShiftEvents.forEach((timeClockShiftEvent) => {
					const { createdByUserId, eventType } = timeClockShiftEvent;
					timeClockShiftEvent.user = userMap[createdByUserId] || {
						firstName: 'Missing',
						lastName: '',
					};

					if (eventType !== 'userClockIn' && eventType !== 'userClockOut') {
						hasManagerEvent = true;
					}
				});

				shiftForClipboard += `Shift ${
					i + 1
				} : Clock In / Out (hours):${clockInDateTimeDisplay} / ${clockOutDateTimeDisplay} (${durationDisplay})\n`;

				if (auditStatus === 'ERROR' || auditStatus === 'WARNING') {
					hasErrorOrWarning = true;
				}
				totalDuration += durationDiff;
				clockIns.push(clockInDateTimeDisplay);
				clockOuts.push(clockOutDateTimeDisplay);
				durations.push(durationDisplay);
				allEvents.push(...timeClockShiftEvents);
				allAudits.push({ auditStatus, auditReason });
			});

			const firstShift = _.first(orderedShifts);

			const row = {
				key: timeClockShiftId,
				userDisplay,
				shiftForUserId,
				supervisorName,
				locationDisplay: timeClockLocation.display,
				dowDisplay,
				totalDuration,
				clockInDateTime: firstShift.clockInDateTime,
				clockOutDateTime: firstShift.clockOutDateTime,
			};

			row.totalDurationDisplay = moment
				.duration(totalDuration)
				.format('d [days], h [hrs], m [min]');

			row.clockInDisplay = clockIns.map((clockIn, i) => {
				return (
					<div
						key={`ci_${timeClockShiftId}_${i}`}
						className={i ? classes.textDivider : classes.tinyPadding}
					>
						{clockIn}
					</div>
				);
			});

			row.clockOutDisplay = clockOuts.map((clockOut, i) => {
				return (
					<div
						key={`co_${timeClockShiftId}_${i}`}
						className={i ? classes.textDivider : classes.tinyPadding}
					>
						{clockOut}
					</div>
				);
			});

			row.durationDisplay = durations.map((duration, i) => {
				return (
					<div
						key={`dur_${timeClockShiftId}_${i}`}
						className={i ? classes.textDivider : classes.tinyPadding}
					>
						{duration}
					</div>
				);
			});

			row.shiftButtons = (
				<div className={classes.paddedContainer}>{this.renderButtons(orderedShifts)}</div>
			);

			if (this.props.paycomPunchInfoByTimeClockShiftId) {
				row.punchTypesDisplay = orderedShifts.map((shift, i) => {
					return (
						<div
							key={`punches_${shift.timeClockShiftId}`}
							className={i ? classes.textDivider : classes.tinyPadding}
							style={{ whiteSpace: 'nowrap' }}
						>
							{this.renderPunchTypes(shift)}
						</div>
					);
				});
			}

			row.exportedDisplay = orderedShifts.map(({ exportedInExponentFtpRecordId }, i) => {
				return (
					<div key={`exported_${timeClockShiftId}_${i}`} className={i ? classes.textDivider : ''}>
						{exportedInExponentFtpRecordId ? <CheckIcon style={{ height: 18 }} /> : '-'}
					</div>
				);
			});

			row.detailsDisplay = (
				<div
					onMouseEnter={(event) => {
						this.handlePopoverOpen(event, orderedShifts);
					}}
					onMouseLeave={this.handlePopoverClose}
				>
					<Button
						size="small"
						variant={hasManagerEvent ? 'contained' : 'outlined'}
						color="primary"
						className={classes.noteCell}
					>
						{allEvents.length}
					</Button>
				</div>
			);

			if (hasErrorOrWarning) {
				row.auditDisplay = this.renderAudits(orderedShifts);
			} else {
				row.auditDisplay = '-';
			}

			let clipboardText =
				`Employee: ${userDisplay}\n` +
				`Supervisor: ${supervisorName}\n` +
				`Total Hours: ${row.totalDurationDisplay}\n` +
				shiftForClipboard;

			if (_.first(orderedShifts).auditReason) {
				clipboardText += `==> Flagged: ${_.first(orderedShifts).auditReason}`;
			}

			const onClick = () => {
				this.copyToClipboard(`${userDisplay} shift`, clipboardText);
			};

			row.clipboardDisplay = <div className={classes.copyToClipboardIcon} onClick={onClick} />;

			timeClockShiftRows.push(row);
		});

		const newState = {
			savingStatus: 'done',
			refreshId: this.state.refreshId + 1,
			timeClockShiftRows,
			userMap,
		};
		this.setState(newState);
	};

	render = () => {
		const { classes } = this.props;
		const { isSearching } = this.state;

		return (
			<>
				<Grid spacing={2} container>
					<Grid item xs={12}>
						{isSearching && (
							<div className={classes.runningSearch}>
								<CircularProgress />
								<span style={{ paddingLeft: 10 }}>Searching...</span>
							</div>
						)}
						{!isSearching && this.renderRowResults()}
					</Grid>
				</Grid>
				{this.renderDialogs()}
			</>
		);
	};

	renderButtons = (shifts) => {
		const { classes } = this.props;
		return shifts.map((timeClockShift, i) => {
			const className = i ? classes.buttonDivider : '';
			return (
				<div
					key={`buttons_${timeClockShift.timeClockShiftId}`}
					style={{ display: 'flex', alignItems: 'center' }}
					className={className}
				>
					<Button
						variant={'outlined'}
						size={'small'}
						className={classes.button}
						onClick={() => this.updateEmployee({ timeClockShift })}
					>
						Update
					</Button>

					{!timeClockShift.clockOutDateTime && (
						<Button
							size={'small'}
							variant={'outlined'}
							className={classes.button}
							onClick={() => this.clockOutEmployee({ timeClockShift })}
							style={{ marginLeft: 3 }}
						>
							Clock Out
						</Button>
					)}

					<IconButton
						size={'small'}
						className={classes.removeButton}
						onClick={() => {
							this.removeShift({ timeClockShift });
						}}
					>
						<DeleteIcon fontSize="small" />
					</IconButton>
				</div>
			);
		});
	};

	renderPunchTypeAcronym = (punchType) => {
		if (!punchType) {
			return '—';
		}
		const description = punchTypeDescriptions[punchType];
		if (!description) {
			return punchType;
		}
		return (
			<Tooltip title={description} arrow placement="top">
				<span
					style={{
						textDecoration: 'underline dotted',
						textUnderlineOffset: 2,
						cursor: 'help',
					}}
				>
					{punchType}
				</span>
			</Tooltip>
		);
	};

	renderPunchTypes = (shift) => {
		const punchInfo = this.props.paycomPunchInfoByTimeClockShiftId[shift.timeClockShiftId] || {};
		return (
			<span>
				{this.renderPunchTypeAcronym(punchInfo.clockInPunchType)}
				{' / '}
				{this.renderPunchTypeAcronym(punchInfo.clockOutPunchType)}
			</span>
		);
	};

	renderAudits = (shifts) => {
		const { classes, compactAuditFlags } = this.props;

		if (compactAuditFlags) {
			return this.renderCompactAudits(shifts);
		}

		let lastReason = '';
		return (
			<div
				style={{
					display: 'flex',
					margin: 5,
					padding: 15,
					//border: "1px solid #fdd",
					borderRadius: '2px',
				}}
			>
				<div>
					{_.values(shifts).map((timeClockShift, i) => {
						const { timeClockShiftId, auditStatus, auditReason } = timeClockShift;

						if (lastReason === auditReason) {
							return null;
						}

						lastReason = auditReason;

						const className = i ? classes.textDivider : '';
						return (
							<div
								key={`audits_${timeClockShiftId}`}
								style={{ display: 'flex' }}
								className={className}
							>
								{auditStatus === 'WARNING' && <span className={classes.miniWarningIcon} />}

								{auditStatus === 'ERROR' && <ErrorIcon className={classes.miniErrorIcon} />}
								<span>{auditReason}</span>
							</div>
						);
					})}
				</div>
				<div style={{ marginLeft: 5 }}>
					<Button
						variant={'outlined'}
						size={'small'}
						className={classes.button}
						color="primary"
						onClick={() => this.clearAudit(shifts)}
					>
						Clear
					</Button>
				</div>
			</div>
		);
	};

	//- Icon-only audit flags: hover the icon to see the problem and clear the flag
	renderCompactAudits = (shifts) => {
		const { classes } = this.props;

		let lastReason = '';
		return (
			<div style={{ display: 'flex', alignItems: 'center' }}>
				{_.values(shifts).map((timeClockShift) => {
					const { timeClockShiftId, auditStatus, auditReason } = timeClockShift;

					if (auditStatus !== 'ERROR' && auditStatus !== 'WARNING') {
						return null;
					}
					if (lastReason === auditReason) {
						return null;
					}
					lastReason = auditReason;

					return (
						<Tooltip
							key={`audits_${timeClockShiftId}`}
							interactive
							arrow
							title={
								<div style={{ fontSize: 13, padding: 5 }}>
									<div>{auditReason}</div>
									<Button
										variant={'outlined'}
										size={'small'}
										style={{ color: '#fff', borderColor: '#fff', marginTop: 8 }}
										onClick={() => this.clearAudit(shifts)}
									>
										Clear Flag
									</Button>
								</div>
							}
						>
							<span style={{ display: 'inline-flex', cursor: 'help' }}>
								{auditStatus === 'WARNING' ? (
									<span className={classes.miniWarningIcon} />
								) : (
									<ErrorIcon className={classes.miniErrorIcon} />
								)}
							</span>
						</Tooltip>
					);
				})}
			</div>
		);
	};

	renderRowResults = () => {
		// const { classes } = this.props;
		const { timeClockShiftRows } = this.state;

		if (!timeClockShiftRows) {
			return null;
		}
		const columns = [];

		if (this.props.includeCopyPasteColumn) {
			columns.push({ label: '', noSort: true, displayId: 'clipboardDisplay' });
		}

		columns.push(
			{ label: 'Employee', sortId: 'userDisplay', displayId: 'userDisplay' },
			{
				label: 'Supervisor',
				sortId: 'supervisorName',
				displayId: 'supervisorName',
			},
			{
				label: 'Total Hours',
				sortId: 'totalDuration',
				displayId: 'totalDurationDisplay',
			},
			{
				label: 'Clock In',
				sortId: 'clockInDateTime',
				displayId: 'clockInDisplay',
				padding: 'none',
			},
			{
				label: 'Clock Out',
				sortId: 'clockOutDateTime',
				displayId: 'clockOutDisplay',
				padding: 'none',
			},
			{
				label: 'Hours',
				sortId: 'durationDiff',
				displayId: 'durationDisplay',
				padding: 'none',
			}
		);

		if (this.props.includeExportedColumn) {
			columns.push({
				displayId: 'exportedDisplay',
				sortId: 'exportedInExponentFtpRecordId',
				label: 'Exp',
				padding: 'none',
			});
		}

		if (this.props.paycomPunchInfoByTimeClockShiftId) {
			columns.push({
				label: 'Punch Types',
				noSort: true,
				displayId: 'punchTypesDisplay',
				padding: 'none',
			});
		}

		columns.push(
			{
				label: 'Update',
				sortId: 'shiftButtons',
				displayId: 'shiftButtons',
				padding: 'none',
			},
			{
				sortId: 'auditStatus',
				displayId: 'auditDisplay',
				label: 'Audit Flag',
				padding: 'none',
			},

			/*
      {
        label: "Location",
        sortId: "locationDisplay",
        displayId: "locationDisplay",
      },
      */
			{
				sortId: 'detail',
				noSort: true,
				displayId: 'detailsDisplay',
				label: 'Notes',
			}
		);

		return (
			<EnhancedTable
				refreshId={this.state.refreshId}
				rows={timeClockShiftRows}
				columns={columns}
				isDense={true}
				defaultOrderBy={'clockInDateTime'}
				defaultOrder={'desc'}
			/>
		);
	};

	renderDialogs = () => {
		const { classes } = this.props;
		return (
			<>
				<ClockOutEmployeeDialog
					open={this.state.isClockOutEmployeeDialogOpen}
					onClose={this.handleCloseClockOutEmployeeDialog}
					timeClockShift={this.state.timeClockShiftForClockOut}
					timeClockUserMap={this.state.userMap}
					afterSave={this.afterClockOutEmployee}
				/>

				<UpdateEmployeeClockInDialog
					open={this.state.isChangeClockInOpen}
					onClose={this.changeClockInClose}
					timeClockShift={this.state.timeClockShiftForClockIn}
					userMap={this.props.userMap}
					afterSave={this.afterUpdateEmployee}
				/>

				<UpdateEmployeeTimeShiftDialog
					open={this.state.isUpdateEmployeeDialogOpen}
					onClose={this.handleCloseUpdateEmployeeDialog}
					timeClockShift={this.state.timeClockShiftForUpdate}
					timeClockUserMap={this.state.userMap}
					afterSave={this.afterUpdateEmployee}
				/>

				<ClearTimeShiftAudit
					open={this.state.isClearAuditDialogOpen}
					onClose={this.handleCloseClearAuditDialog}
					timeClockShifts={this.state.timeClockShiftsForClearAudit}
					timeClockUserMap={this.state.userMap}
					afterSave={this.afterClearAudit}
				/>

				<RemoveTimeShiftDialog
					open={this.state.isRemoveShiftDialogOpen}
					onClose={this.handleCloseRemoveShiftDialog}
					timeClockShift={this.state.timeClockShiftForRemove}
					timeClockUserMap={this.state.userMap}
					afterSave={this.afterRemoveShift}
				/>

				<Popover
					id="popover"
					className={classes.popover}
					classes={{
						paper: classes.paper,
					}}
					open={!!this.state.popoverAnchor}
					anchorEl={this.state.popoverAnchor}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					onClose={this.state.handlePopoverClose}
					disableRestoreFocus
				>
					{!_.isEmpty(this.state.popoverTimeClockShifts) &&
						this.renderPopoverContents(this.state.popoverTimeClockShifts)}
				</Popover>
				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
					open={this.state.snackbarIsOpen}
					autoHideDuration={2000}
					onClose={this.handleSnackbarClose}
					TransitionComponent={SlideUpTransition}
				>
					<SnackbarContent
						className={classes.snackbarSuccess}
						aria-describedby="client-snackbar"
						message={
							<span id="client-snackbar" className={classes.snackbarMessage}>
								<CheckCircleIcon className={classes.snackbarIcon} />
								<strong>{this.state.snackbarMessage} </strong>&nbsp;copied to clipboard
							</span>
						}
						action={[
							<IconButton
								key="close"
								aria-label="close"
								color="inherit"
								onClick={this.handleSnackbarClose}
							>
								<CloseIcon className={classes.icon} />
							</IconButton>,
						]}
					/>
				</Snackbar>
			</>
		);
	};

	handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({ snackbarIsOpen: false });
	};

	renderPopoverContents = (timeClockShifts) => {
		const { classes } = this.props;
		return (
			<div className={classes.popoverContainer}>
				{timeClockShifts.map((timeClockShift, i) => {
					const { timeClockShiftId, timeClockShiftEvents } = timeClockShift;
					return (
						<div
							key={`shiftForEvent_${timeClockShiftId}`}
							className={classes.popoverShiftContainer}
						>
							<div className={classes.popoverShiftTitle}>Shift {i + 1}</div>

							{timeClockShiftEvents.map((timeClockShiftEvent, i) => {
								const {
									dateCreated,
									timeClockShiftEventId,
									eventType,
									note,
									user,
									changeLog,
								} = timeClockShiftEvent;

								const dateCreatedFormatted = moment(dateCreated).format('M/D h:mm a');

								const className = i ? classes.eventDivider : '';
								if (eventType === 'userClockIn' || eventType === 'userClockOut') {
									const verb = eventType === 'userClockIn' ? 'clocked in' : 'clocked out';
									return (
										<div key={timeClockShiftEventId} className={className}>
											<div style={{ whiteSpace: 'pre-line' }}>
												{user.firstName} {user.lastName} {verb}
											</div>
											{!!note && <div className={classes.eventNote}>Reason : {note}</div>}
											<div className={classes.eventDateTime}>{dateCreatedFormatted}</div>
										</div>
									);
								} else {
									const verb = managerEventToDisplay[eventType] || 'performed unknown action';
									return (
										<div key={timeClockShiftEventId} className={className}>
											<div style={{ whiteSpace: 'pre-line' }}>
												<strong>
													{user.firstName} {user.lastName}
												</strong>{' '}
												{verb}
											</div>
											<div className={classes.eventNote}>Reason : {note}</div>
											{!!changeLog && (
												<div className={classes.eventNote}>Change Log : {changeLog}</div>
											)}
											<div className={classes.eventDateTime}>{dateCreatedFormatted}</div>
										</div>
									);
								}
							})}
						</div>
					);
				})}
			</div>
		);
	};

	handlePopoverOpen = (event, timeClockShifts) => {
		this.setState({
			popoverTimeClockShifts: timeClockShifts,
			popoverAnchor: event.currentTarget,
		});
	};
	handlePopoverClose = () => {
		this.setState({
			popoverAnchor: null,
			popoverTimeClockShifts: null,
		});
	};

	clockOutEmployee = ({ timeClockShift }) => {
		this.setState({
			timeClockShiftForClockOut: timeClockShift,
			isClockOutEmployeeDialogOpen: true,
		});
	};
	handleCloseClockOutEmployeeDialog = () => {
		this.setState({
			timeClockShiftForClockOut: null,
			isClockOutEmployeeDialogOpen: false,
		});
	};
	afterClockOutEmployee = () => {
		this.runApi();
	};

	// update
	updateEmployee = ({ timeClockShift }) => {
		if (timeClockShift.clockOutDateTime) {
			this.setState({
				timeClockShiftForUpdate: timeClockShift,
				isUpdateEmployeeDialogOpen: true,
			});
		} else {
			this.setState({
				timeClockShiftForClockIn: timeClockShift,
				isChangeClockInOpen: true,
			});
		}
	};

	changeClockInClose = () => {
		this.setState({
			timeClockShiftForClockIn: null,
			isChangeClockInOpen: false,
		});
	};

	handleCloseUpdateEmployeeDialog = () => {
		this.setState({
			timeClockShiftForUpdate: null,
			isUpdateEmployeeDialogOpen: false,
		});
	};
	afterUpdateEmployee = () => {
		this.runApi();
	};

	// clear
	clearAudit = (timeClockShifts) => {
		this.setState({
			timeClockShiftsForClearAudit: timeClockShifts,
			isClearAuditDialogOpen: true,
		});
	};
	handleCloseClearAuditDialog = () => {
		this.setState({
			timeClockShiftsForClearAudit: null,
			isClearAuditDialogOpen: false,
		});
	};
	afterClearAudit = () => {
		this.runApi();
	};

	removeShift = ({ timeClockShift }) => {
		this.setState({
			timeClockShiftForRemove: timeClockShift,
			isRemoveShiftDialogOpen: true,
		});
	};

	handleCloseRemoveShiftDialog = () => {
		this.setState({
			timeClockShiftForRemove: null,
			isRemoveShiftDialogOpen: false,
		});
	};
	afterRemoveShift = () => {
		this.runApi();
	};

	copyToClipboard(snackbarMessage, text) {
		this.setState({
			snackbarMessage,
			snackbarIsOpen: true,
		});

		if (!navigator.clipboard) {
			this.fallbackCopyTextToClipboard(text);
			return;
		}
		navigator.clipboard.writeText(text).then(
			function () {},
			function (err) {
				console.error('Async: Could not copy text: ', err);
			}
		);
	}

	fallbackCopyTextToClipboard(text) {
		const textArea = document.createElement('textarea');
		textArea.value = text;
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			const successful = document.execCommand('copy');
			const msg = successful ? 'successful' : 'unsuccessful';
			console.warn('Fallback: Copying text command was ' + msg);
		} catch (err) {
			console.error('Fallback: Oops, unable to copy', err);
		}

		document.body.removeChild(textArea);
	}
}

ShiftTable.propTypes = {
	//- Either give the table an API call to run (method + params)...
	method: PropTypes.string,
	params: PropTypes.object,
	//- ...or hand it already-fetched results (apiResults mode). onRefreshNeeded is
	//- called instead of re-running the API when shifts change from this table.
	apiResults: PropTypes.object,
	onRefreshNeeded: PropTypes.func,
	excludeShiftIds: PropTypes.array,
	//- When set, adds a Punch Types column ({ [timeClockShiftId]: { clockInPunchType, clockOutPunchType } })
	paycomPunchInfoByTimeClockShiftId: PropTypes.object,
	//- Audit Flag column shows just the icon; hover for the problem + Clear button
	compactAuditFlags: PropTypes.bool,
	classes: PropTypes.object.isRequired,
	authUser: PropTypes.object,
	paused: PropTypes.bool,
	refreshId: PropTypes.number,
	onDataCallback: PropTypes.func,
	includeCopyPasteColumn: PropTypes.bool,
	includeExportedColumn: PropTypes.bool,
};

export default _.flow([withStyles(styles), AuthUserContainer])(ShiftTable);
